class LocalStorage {
    static set = function (key, value) {
        localStorage.setItem(key, value);
    };

    static get = function (key) {
        return localStorage.getItem(key) || undefined;
    };

    static getAllKeys = function () {
        return { ...localStorage };
    };

    static removeAll = function () {
        localStorage.clear();
    };

    static remove = function (key) {
        localStorage.removeItem(key);
    };

    static getOrSet = function (key, value) {
        let result = localStorage.getItem(key);
        if (!result) {
            localStorage.setItem(key, value);
            result = value;
        }
        return result;
    };
}

export { LocalStorage };
